import { render, staticRenderFns } from "./CreateGym.vue?vue&type=template&id=159c2dd3&"
import script from "./CreateGym.vue?vue&type=script&lang=js&"
export * from "./CreateGym.vue?vue&type=script&lang=js&"
import style0 from "./CreateGym.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports